// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.administration-reservations {
  button.reject {
    margin-right: 3rem;
  }
  button.action {
    margin-left: 1rem;
  }

  .card {
    &.pending {
      .card-title {
        color: var(--color-elevated-warn);
      }
    }
    &.approved .approval {
      .data-label,
      .data-value {
        color: var(--color-elevated-success);
      }
    }
    &.rejected .approval {
      .data-label,
      .data-value {
        color: var(--color-elevated-warn);
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/style/panes/administration/administration_reservations.css"],"names":[],"mappings":";;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE;MACE;QACE,iCAAiC;MACnC;IACF;IACA;MACE;;QAEE,oCAAoC;MACtC;IACF;IACA;MACE;;QAEE,iCAAiC;MACnC;IACF;EACF;AACF","sourcesContent":["\r\n\r\n.administration-reservations {\r\n  button.reject {\r\n    margin-right: 3rem;\r\n  }\r\n  button.action {\r\n    margin-left: 1rem;\r\n  }\r\n\r\n  .card {\r\n    &.pending {\r\n      .card-title {\r\n        color: var(--color-elevated-warn);\r\n      }\r\n    }\r\n    &.approved .approval {\r\n      .data-label,\r\n      .data-value {\r\n        color: var(--color-elevated-success);\r\n      }\r\n    }\r\n    &.rejected .approval {\r\n      .data-label,\r\n      .data-value {\r\n        color: var(--color-elevated-warn);\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
